import { render } from "./CustomerTabs.vue?vue&type=template&id=708f423e"
import script from "./CustomerTabs.vue?vue&type=script&lang=js"
export * from "./CustomerTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__